// components/cookiebanner/useOuCookies.ts
import { useCookies } from 'react-cookie'
import { consentMode, COOKIE_DEFAULT_OPTIONS } from 'lib/cookieConfig'

export type ConsentState = {
  necessary: boolean
  analytical: boolean
  marketing: boolean
}

export const useOuCookies = () => {
  const [cookies, setCookie] = useCookies([consentMode.necessary, consentMode.analytical, consentMode.marketing, 'NEXT_LOCALE'])
  const isClient = typeof window !== 'undefined'

  const setCustomCookie = (name: string, value: string, options: object = {}) => {
    setCookie(name, value, { ...COOKIE_DEFAULT_OPTIONS, ...options })
  }

  return {
    cookies,
    setCookie,
    setCustomCookie,
    consentNecessary: true,
    consentAnalytical: isClient ? (cookies[consentMode.analytical] ?? false) : false,
    consentMarketing: isClient ? (cookies[consentMode.marketing] ?? false) : false,
    NEXT_LOCALE: isClient ? cookies['NEXT_LOCALE'] : undefined,
  }
}
